import { StyledDivider } from './styles'

export function Divider({ overflow = false, sx = {}, ...props }) {
  return <StyledDivider sx={overflow ? { ...sx, width: '200%', marginLeft: '-50%' } : sx} {...props} />
}
